import { Card } from "components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import type { TaxClosingTabs } from "@/services/tax-closing";

import { SummaryCardsRow } from "./summary-cards-row";
import { ReprocessSchedulersPanel } from "./reprocess-schedulers-panel";
import {
  TAX_CLOSING_TABS,
  TAX_CLOSING_TAB_ORDER,
  type TaxClosingTabKey,
} from "./tabs-config";

interface DataReadyViewProps {
  fiscalData: TaxClosingTabs;
  jobId: string;
  activeTab: TaxClosingTabKey;
  onTabChange: (value: string) => void;
}

export function DataReadyView({
  fiscalData,
  jobId,
  activeTab,
  onTabChange,
}: DataReadyViewProps) {
  return (
    <div className="flex flex-col gap-6">
      <SummaryCardsRow summary={fiscalData.summary} />

      <Card className="p-0 overflow-hidden">
        <Tabs value={activeTab} onValueChange={onTabChange}>
          <div className="border-b bg-muted/30">
            <TabsList className="h-auto p-0 bg-transparent rounded-none w-full justify-start">
              {TAX_CLOSING_TAB_ORDER.map((key) => {
                const tab = TAX_CLOSING_TABS[key];
                const Icon = tab.Icon;
                return (
                  <TabsTrigger
                    key={key}
                    value={key}
                    className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background data-[state=active]:shadow-none px-6 py-3 gap-2 font-medium"
                  >
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </TabsTrigger>
                );
              })}
            </TabsList>
          </div>

          <div className="p-5">
            {TAX_CLOSING_TAB_ORDER.map((key) => (
              <TabsContent key={key} value={key} className="mt-0">
                {TAX_CLOSING_TABS[key].render({ data: fiscalData, jobId })}
              </TabsContent>
            ))}
          </div>
        </Tabs>
      </Card>

      <ReprocessSchedulersPanel jobId={jobId} />
    </div>
  );
}
